module.exports = __webpack_public_path__ + "img/valentine-banner.675c913b.jpg";